export default {"src":"/_next/static/media/bonus-track-points-icon.b1806b98.svg","height":18,"width":26,"blurWidth":0,"blurHeight":0};